"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
const lazyLoadWithFallback = (importFunc) => {
  return React.lazy(importFunc);
};
exports.lazyLoadWithFallback = lazyLoadWithFallback;
